module.exports = __webpack_public_path__ + "static/img/11.9b85a8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/11.png
// module id = COTr
// module chunks = 0